// extracted by mini-css-extract-plugin
export default {"countdown":"B0-z","srOnly":"C0-z"};